// Web build identity. Mirrors the app version so backend update checks and
// analytics group web sessions with the matching mobile release.
import pkg from '../../../package.json';

export const APP_VERSION: string = (pkg as { version?: string }).version ?? '0.0.0';
export const BUILD_NUMBER = 'web';
